import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { describeApiError } from '../utils/format';

/**
 * Shows the loading, error, or empty state of an `useApi` result, and the children otherwise.
 * Data that is already on screen stays visible while a refresh runs behind it.
 */
export default function AsyncState({ state, retry, isEmpty = false, empty = null, children }) {
  const { language } = useLanguage();
  const t = translations[language];

  if (state.loading && !state.data) {
    return <p className="hint" role="status">{t.loading}</p>;
  }
  if (state.error && !state.data) {
    return <div className="notice notice--error" role="alert">
      <span>{describeApiError(state.error, t, t.loadFailed)}</span>
      {retry && <button className="btn btn--pill" type="button" onClick={retry}>{t.retry}</button>}
    </div>;
  }
  if (isEmpty) return empty;
  return children;
}
